module.exports = __webpack_public_path__ + "img/carousel.3a3add97.gif";